import {Routes} from "@angular/router";
import {SelfServiceRoutes} from "./self-service-routes";
import {ForgotPasswordComponent} from "./forgot-password/forgot-password.component";
import {ResetPasswordComponent} from "./reset-password/reset-password.component";

export const SELFSERVICE_ROUTES: Routes = [
  {
    path: SelfServiceRoutes.ForgotPassword,
    component: ForgotPasswordComponent,
    title: "Passwort vergessen"
  },
  {
    path: SelfServiceRoutes.ResetPassword,
    component: ResetPasswordComponent,
    title: "Passwort zurücksetzen"
  }
]
